<template>
  <div>
    <div>
      <ActionListServerSide
        ref="actionList"
        :load-items-callback="loadItemsCallback"
        :load-item-details-callback="loadItemDetailsCallback"
        :item-caching-enabled="itemCachingEnabled"
        :filters="filters"
        :actions="actions"
        :call-to-actions="callToActions"
        :fixed-filters="fixedFilters"
        :empty-text="$t('noFormsOfPaymentFound')"
        :import-data-values="importDataValues"
        @item-selected="handleItemSelected"
      >
        <template v-slot:item="{ item, index, selectItem }">
          <FormOfPaymentListItem
            :key="item.uuid"
            :form-of-payment="item"
            :select-item="selectItem"
            @selectFormOfPayment="handleItemSelected"
          />
          <v-divider
            :key="index"
            inset
          />
        </template>
      </ActionListServerSide>
    </div>
  </div>
</template>

<script>
import FormOfPaymentListItem from './FormOfPaymentListItem'
import ActionListServerSide from '../common/list/ActionListServerSide'

export default {
  name: 'FormOfPaymentListServerSide',
  props: {
    loadItemsCallback: {
      type: Function,
      required: true
    },
    loadItemDetailsCallback: {
      type: Function,
      default: null
    },
    itemCachingEnabled: {
      type: Boolean,
      default: true
    },
    fixedFilters: {
      type: Array,
      default: () => []
    },
    callToActions: {
      type: Array,
      default: () => []
    }
  },
  components: {
    FormOfPaymentListItem,
    ActionListServerSide
  },
  data() {
    return {
      filters: [
        {
          key: 'amount',
          label: this.$t('amount'),
          type: 'number',
          value: null,
          operator: 'equals'
        },
        {
          key: 'created',
          label: this.$t('dateCreated'),
          type: 'datetime',
          value: [0, 0],
          operator: 'between'
        },
        {
          key: 'customer.address.name_line',
          label: this.$t('customerName'),
          type: 'text',
          value: null,
          operator: 'contains'
        },
        {
          key: 'customer.email',
          label: this.$t('Customer Email'),
          type: 'text',
          value: null,
          operator: 'contains'
        },
        {
          key: 'item.title',
          label: this.$t('itemTitle'),
          type: 'text',
          value: null,
          operator: 'contains'
        }
      ]
    }
  },
  computed: {
    importDataValues() {
      return {
        createCallback: this.createGiftcard,
        updateCallback: null,
        defaultCreateObject: {},
        schema: [
          {
            property: 'remoteID',
            title: 'Code',
            required: true,
            type: 'String',
            defaultValue: null,
            value: null
          },
          {
            property: 'amount',
            title: 'Amount',
            required: true,
            type: 'Float',
            defaultValue: null,
            value: null
          },
          {
            property: 'item',
            title: 'Item',
            required: true,
            type: 'String',
            defaultValue: null,
            value: null
          },
          {
            property: 'expiryMonth',
            title: 'Expiry Month',
            required: true,
            type: 'String',
            defaultValue: null,
            value: null
          },
          {
            property: 'expiryYear',
            title: 'Expiry Year',
            required: true,
            type: 'String',
            defaultValue: null,
            value: null
          }
        ]
      }
    },
    actions() {
      return this.$store.getters.bulkOperationsByRoute('forms-of-payment')
    }
  },
  methods: {
    createGiftcard(value) {
      return this.$store.dispatch('createGiftcard', { fop: value })
    },
    handleItemSelected(item) {
      this.$emit('selectFormOfPayment', item)
    },
    async exportAllItems() {
      if (this.$refs.actionList) {
        await this.$refs.actionList.exportAllItems()
      }
    },
    refresh() {
      if (this.$refs.actionList) {
        this.$refs.actionList.refresh()
      }
    }
  }
}
</script>
